import { render } from "./HomePage.vue?vue&type=template&id=559d436b"
const script = {}

import exportComponent from "E:\\Work\\ITLinked\\2022\\stat-calculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__